import React from 'react';
import { TweenLite } from 'gsap';

interface IOwnProps {
    modifierClass?: string;
}

interface IState {
    selectedTabIndex: number;
    isOpen: boolean;
}

type Props = IOwnProps;

class Tab extends React.Component<Props, IState> {
    private displayedTabItemStyle = { display: 'block', opacity: 1 };
    private tab = React.createRef<HTMLUListElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            selectedTabIndex: 0,
            isOpen: false
        }
    }

    public componentDidUpdate() {
        if (Array.isArray(this.props.children)) {
            const childrenCandidates = this.props.children.filter(c => !!c);

            if (this.state.selectedTabIndex >= childrenCandidates.length) {
                this.setState({ selectedTabIndex: 0 });
            }
        }
    }

    public render() {
        return <React.Fragment>
            {this.renderHeaders()}
            {this.renderContents()}
        </React.Fragment>;
    }

    private renderHeaders = () => {
        if (!this.props.children) {
            return null;
        }

        const childrenCandidates: any = Array.isArray(this.props.children)
            ? this.props.children.filter(c => !!c)
            : this.props.children;
        const selected = Array.isArray(childrenCandidates) && this.state.selectedTabIndex < childrenCandidates.length ? childrenCandidates[this.state.selectedTabIndex] : null;

        return <ul className={'tabs'.cAppend(this.props.modifierClass).cAppend(this.state.isOpen, 'is-open')} ref={this.tab}>
            <li className="tabs__toggle-mobile js--toggle-mobile" onClick={this.toggleMobile}>
                {Array.isArray(this.props.children) && selected && selected.props
                    ? selected.props.header
                    : ''}
            </li>
            {Array.isArray(this.props.children)
                ? childrenCandidates.map((e: any, i: any) => this.renderHeader(e, i))
                : this.renderHeader(this.props.children, 0)}
        </ul>;
    }

    private renderHeader = (tab: any, index: number) => {
        if (!tab || !tab.props || !tab.props.header) {
            // throw Error('Element inserted in TabList did not support the TabHeader interface.');
            return null;
        }

        const handleClick = () => {
            if (this.state.isOpen) {
                TweenLite.to(this.tab.current, 0.25, { height: 50 });
            }

            this.setState({
                selectedTabIndex: index,
                isOpen: false
            });
        }

        return <li key={index} className={index === this.state.selectedTabIndex ? 'tabs__item is-active' : 'tabs__item'} onClick={handleClick}>{tab.props.header}</li>;
    }

    private renderContents = () => {
        if (!this.props.children) {
            return null;
        }

        const contentTab: any = Array.isArray(this.props.children) ? this.props.children.filter(c => !!c)[this.state.selectedTabIndex] : this.props.children;

        return <div style={this.displayedTabItemStyle}>
            {contentTab}
        </div>;
    }

    private toggleMobile = () => {
        if (this.state.isOpen) {
            TweenLite.to(this.tab.current, 0.25, { height: 50 });
        } else {
            TweenLite.set(this.tab.current, { height: 'auto' });
            TweenLite.from(this.tab.current, 0.25, { height: 50 });
        }

        this.setState(prevState => (
            { isOpen: !prevState.isOpen }
        ));
    }
}

export default Tab;